import { useCallback, useMemo } from "react";
import { view } from "../../../../utils/API";
import { renderCell } from "../../../../utils/helper";

import { LeftArrowIcon, RightArrowIcon } from "../../../Icons";
import {
  StyledPopUpTitle,
  StyledPopupTitleWrapper,
} from "../../CustomPopupWrapper-styled";
import getAllowedFields from "../../helpers/getAllowedFields";
import getClusterAttributeFields from "../../helpers/getClusterAttributeFields";
import { StyledNavButton } from "../../style/ClusterDetails/ClusterDetails-styled";

const ClusterList = ({
  layer,
  feature,
  clusterFeatures,
  t,
  config,
  goBack,
  savePopup,
  featureIcons,
}) => {
  const cluster = layer.layerConfig.cluster;

  const relatedFeatures = useMemo(
    () =>
      clusterFeatures.filter(
        (feat) =>
          feat.attributes[cluster.clusterAttribute1] ===
          feature.attributes[cluster.clusterAttribute1]
      ),
    [clusterFeatures]
  );

  const fields = useMemo(
    () => getAllowedFields(layer, feature),
    [feature, layer]
  );
  const clusterFields = useMemo(
    () => getClusterAttributeFields(cluster, fields, t),
    [fields, t]
  );

  const renderValue = useCallback(
    (feat) => {
      const value = renderCell(
        clusterFields.field2,
        feat.attributes[clusterFields.field2?.name],
        t,
        config
      );
      return value || featureIcons[feat.getObjectId()];
    },
    [featureIcons, clusterFields, t, config]
  );

  if (!relatedFeatures.length) return null;

  return (
    <div style={{ width: "100%" }}>
      <StyledPopupTitleWrapper>
        <StyledPopUpTitle style={{ justifyContent: "center" }}>
          Total: {relatedFeatures.length}
        </StyledPopUpTitle>
      </StyledPopupTitleWrapper>
      <div style={{ display: "flex", alignItems: "center" }}>
        <StyledNavButton
          onClick={() => {
            goBack();
            view.popup.title =
              clusterFields.fieldTitle1 || layer.getLayerTitle(t);
          }}
        >
          <div
            style={{
              width: 16,
              height: 16,
              minWidth: 16,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <RightArrowIcon width="10" height="10" strokeWidth={1} />
          </div>
          <span style={{ fontSize: 10 }}>{clusterFields.fieldTitle1}</span>
        </StyledNavButton>
        {clusterFields.field2 && (
          <span
            style={{
              marginLeft: 4,
              fontSize: 10,
            }}
          >
            {" "}
            / {clusterFields.fieldTitle2}
          </span>
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          width: "100%",
          marginTop: 12,
        }}
      >
        {relatedFeatures.map((feat) => (
          <StyledNavButton
            key={feat.uid}
            onClick={() => {
              savePopup();
              view.openPopup({
                features: [feat],
                actions: [],
              });
            }}
          >
            <span>{renderValue(feat)}</span>
            <div
              style={{
                width: 20,
                height: 20,
                minWidth: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LeftArrowIcon width="14" height="14" strokeWidth={1} />
            </div>
          </StyledNavButton>
        ))}
      </div>
    </div>
  );
};

export default ClusterList;
